module.exports = __webpack_public_path__ + "static/media/mainimg-06.b1242e93.png";